import BasePivotStore from '@/store/base-pivot-store'

export default new BasePivotStore('clients', 'tasks')



// WEBPACK FOOTER //
// ./src/store/modules/customers-tasks.store.js